import * as api from './apis'
import * as bcApi from './bcApis'

export default {
  api,
  bcApi,
}
